/**
 * i18n — EN/AR with RTL as a first-class dimension (spec: RTL-first).
 * Language changes flip <html lang/dir> so CSS logical properties and
 * :dir() take over; nothing per-component ever hardcodes direction.
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import ar from './ar.json';

export const SUPPORTED_LOCALES = ['en', 'ar'] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];

export function applyDocumentLocale(locale: Locale): void {
  document.documentElement.lang = locale;
  document.documentElement.dir = locale === 'ar' ? 'rtl' : 'ltr';
}

export async function initI18n(initial: Locale): Promise<typeof i18n> {
  await i18n.use(initReactI18next).init({
    resources: { en: { translation: en }, ar: { translation: ar } },
    lng: initial,
    fallbackLng: 'en',
    interpolation: { escapeValue: false }, // React escapes already
    returnEmptyString: false,
  });
  applyDocumentLocale(initial);
  i18n.on('languageChanged', (lng) => applyDocumentLocale(lng as Locale));
  return i18n;
}

export default i18n;
